import { useState } from 'react'
import { format } from 'date-fns'
import { enUS as en, it } from 'date-fns/locale'
import { CalendarIcon } from 'lucide-react'
import { useRouter } from 'next/router'

import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@/components/ui/popover'

import { cn } from '@/lib/utils'

type DatePickerProps = {
  label?: string
  // eslint-disable-next-line no-unused-vars
  onChange?: (selectedDate: string | undefined) => void
}

const DatePicker = ({ onChange, label }: DatePickerProps) => {
  const [date, setDate] = useState<Date>()

  const { locale } = useRouter()

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={'outline'}
          className={cn(
            'w-full justify-start text-left font-normal text-white',
            !date && 'text-muted-foreground',
            'rounded-[.5rem] bg-transparent px-[1.5rem] text-white placeholder:text-dark',
            'h-[4rem] px-[1.5rem] text-[100%]',
            'hover:bg-transparent hover:text-white'
          )}
        >
          <CalendarIcon className="!size-[20px]" strokeWidth={1.5} size={20} />
          {date ? (
            format(date, 'dd/MM/yyyy')
          ) : (
            <span className="text-[#9CA3AF]">{label}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 text-[100%]" align="start">
        <Calendar
          className="[&_*]:!text-[12px]"
          locale={locale === 'it' ? it : en}
          mode="single"
          selected={date}
          onSelect={(e) => {
            setDate(e)
            if (e) {
              const formattedDate = format(e, 'dd/MM/yyyy')
              onChange?.(formattedDate)
            }
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  )
}

export default DatePicker
